import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SectionService } from 'src/app/services/section.service';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-base-section-edit',
  templateUrl: './base-section-edit.component.html',
  styleUrls: ['./base-section-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class BaseSectionEditComponent implements OnInit {

  isSending = false;
  isLoading = true;
  item: any;
  pathUrlList = 'section';
  configFields = [];
  serviceGoogle: GoogleStorageService;
  isUploadingFile = {};

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router,
    protected service: SectionService
  ) { }

  ngOnInit(): void {
    this.searchFormByParams();
  }

  onClickSave() {
    this.isSending = true;
    this.service.save(this.item).toPromise().then(data => {
      this.isSending = false;
      if (!data.success) {
          this.alertService.showError('Error!', data.error.message);
          return;
        }
      this.alertService.showSuccess('Exito!', 'Se ha creado correctamente!.');
      this.navigator.navigateByUrl('/' + this.pathUrlList);
    }).catch(error => {
      this.isSending = false;
      this.alertService.showError('Error!', error);
    });
  }

  loadItem(itemId: number) {
    this.isLoading = true;
    this.service.fetch(itemId).toPromise().then(data => {
      if (!data.success) {
        this.navigator.navigateByUrl('/' + this.pathUrlList);
      }
      this.item = data.response;
      this.isLoading = false;
      console.log(this.item.data.is_show_button_cart);
    });
  }

  searchFormByParams() {
    // Buscar ID del tour
    this.route.data.subscribe(params => {
      if (params.id) {
        this.loadItem(params.id);
      } else {
        this.navigator.navigateByUrl('/section');
      }
    });
  }

  onUploadFiles(files, field, item) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.onUploadFile(element, field, item);
    }
  }

  onUploadFile(file, field, item) {
    this.isUploadingFile[field.key + '_' + field.index] = true;
    this.serviceGoogle.upload(file).toPromise().then(data => {
      this.isUploadingFile[field.key + '_' + field.index] = false;
      if (!data.success) {
        return;
      }
      
      item[field.key] = data.response.url;
    });
  }
}
